<div class="row">
  <div class="col-6 ps-0">
    <rask-tradslag-mall [kontraktReadonly]="kontraktReadonly"></rask-tradslag-mall>
  </div>
  <div class="col-6">
    <rask-radiobutton-group
      #kalkylmetod
      class="w-100"
      label="Kalkylmetod"
      [value]="activeKalkylmetod"
      (change)="kalkylmetodChange(kalkylmetod.value)"
      [buttons]="kalkylmetodButtons"
      [disabled]="kontraktReadonly">
    </rask-radiobutton-group>
  </div>
</div>

@if (loaded) {
  @if (isSnabbkalkylActive) {
    <rask-forkalkyl-snabbkalkyl [readonly]="kontraktReadonly"></rask-forkalkyl-snabbkalkyl>
  } @else {
    <rask-forkalkyl-direktutbyte [readonly]="kontraktReadonly"></rask-forkalkyl-direktutbyte>
  }
}